var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1026 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.996621 679.29088l432.9472-432.77312a46.32064 46.32064 0 0 1 65.48992 0 46.27456 46.27456 0 0 1 0 65.4592l-465.69472 465.50528a46.32064 46.32064 0 0 1-65.4848 0L13.559501 311.97696a46.27456 46.27456 0 0 1 0-65.4592 46.32064 46.32064 0 0 1 65.4848 0L511.996621 679.29088z",
    fill: "#6AAB9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/DropdownArrow.fbfd3f7ab180775da7dbc730a414850b.svg";
export { ForwardRef as ReactComponent };